import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { OrderTicketsContent } from '@starjack/widgets/orderTickets';
import { useTranslation } from 'react-i18next';
import { PageWithLayout } from '@/models/page';
import { QuantityCounter } from '@/components/QuantityCounter/QuantityCounter';
import {
    useParseFileData,
    useValidateImportData,
    columnMapping,
} from '@/utils/dataImport';
import { usePagination } from '@starjack/shared-components';
import { postOrder, postPayOrder } from '@/api/v2/submitOrder';
import { getMoneyAsString } from '@/utils';

const NewConditionLink: PageWithLayout = () => {
    const { t } = useTranslation();
    return (
        <>
            <Helmet>
                <title>{t('ticketOrder.title')} | Starjack Admin</title>
            </Helmet>
            <OrderTicketsContent
                QuantityCounter={QuantityCounter}
                useParseFileData={useParseFileData}
                useValidateImportData={useValidateImportData}
                usePagination={usePagination}
                columnMapping={columnMapping}
                postOrder={postOrder}
                postPayOrder={postPayOrder}
                getMoneyAsString={getMoneyAsString}
                confirmationNumberFormat='b2b'
                showStartDayInTicketHolder={true}
            />
        </>
    );
};

NewConditionLink.isProtected = true;
NewConditionLink.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
NewConditionLink.permissions = [];

export default NewConditionLink;
